import { render, staticRenderFns } from "./Subnav.vue?vue&type=template&id=5604385b&scoped=true&"
import script from "./Subnav.vue?vue&type=script&lang=js&"
export * from "./Subnav.vue?vue&type=script&lang=js&"
import style0 from "./Subnav.vue?vue&type=style&index=0&id=5604385b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604385b",
  null
  
)

export default component.exports